const brianPublicationsDataBooks = [
  {
    year: "2023",
    title: "Special Issue in Honour of Landon Rabern",
    publisher: "Discrete Mathematics",
    volume: "Volume 346, Issue 11",
    editor: "Brian Rabern and D. W. Cranston and H. Keirstead",
    ENTRYTYPE: "book",
    ID: "Rabern2023-RABSII",
    bibtex:
      "@book{Rabern2023-RABSII,\n    year = {2023},\n    title = {Special Issue in Honour of Landon Rabern, Discrete Mathematics},\n    publisher = {Elsevier},\n    editor = {Brian Rabern and D. W. Cranston and H. Keirstead}\n}\n\n",
    url: "https://philpapers.org/rec/RABSII",
    cover:
      "https://raw.githubusercontent.com/brianrabern/rabern/main/src/pages/assets/dm_landon.png",
  },
  {
    year: "2018",
    title:
      "The Science of Meaning: Essays on the Metatheory of Natural Language Semantics",
    publisher: "Oxford University Press",
    editor: "Derek Ball and Brian Rabern",
    address: "Oxford",
    ENTRYTYPE: "book",
    ID: "Ball2018-BALTSO-32",
    bibtex:
      "@book{Ball2018-BALTSO-32,\n    year = {2018},\n    title = {The Science of Meaning: Essays on the Metatheory of Natural Language Semantics},\n    publisher = {Oxford University Press},\n    editor = {Derek Ball and Brian Rabern},\n    address = {Oxford}\n}\n\n",
    url: "https://philpapers.org/rec/BALTSO-32",
    cover:
      "https://raw.githubusercontent.com/brianrabern/rabern/main/src/pages/assets/som_cover.png",
  },
  {
    year: "2018",
    title: "Proceedings of Sinn Und Bedeutung",
    publisher: "Semantics Archives",
    volume: "Volume 21",
    editor:
      "Rob Truswell and Chris Cummins and Caroline Heycock and Brian Rabern and Hannah Rohde",
    ENTRYTYPE: "book",
    ID: "Truswell2018-TRUPOS",
    bibtex:
      "@book{Truswell2018-TRUPOS,\n    year = {2018},\n    title = {Proceedings of Sinn Und Bedeutung 21},\n    publisher = {Semantics Archives},\n    editor = {Rob Truswell and Chris Cummins and Caroline Heycock and Brian Rabern and Hannah Rohde}\n}\n\n",
    url: "https://philpapers.org/rec/TRUPOS",
    cover:
      "https://raw.githubusercontent.com/brianrabern/rabern/main/src/pages/assets/sinn_cover.png",
  },
  {
    year: "2012",
    title: "The Semantics of Contextual Shifting and Sensitivity",
    publisher: "Dissertation: The Australian National University",
    author: "Brian Rabern",
    ENTRYTYPE: "phdthesis",
    ID: "Rabern2012-BRIMAC-3",
    bibtex:
      "@phdthesis{Rabern2012-BRIMAC-3,\n    year = {2012},\n    title = {The Semantics of Contextual Shifting and Sensitivity},\n    school = {The Australian National University},\n    author = {Brian Rabern}\n}\n\n",
    url: "https://philpapers.org/rec/BRIMAC-3",
    cover:
      "https://raw.githubusercontent.com/brianrabern/rabern/main/src/pages/assets/diss.png",
  },
];

export default brianPublicationsDataBooks;
